'use client'
import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import clsx from 'clsx'
import type { ComponentPropsWithRef } from 'react'

const TooltipProvider = TooltipPrimitive.Provider

const Tooltip = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

const TooltipContent = (props: ComponentPropsWithRef<typeof TooltipPrimitive.Content>) => {
    const { className, children, sideOffset = 4, ...otherProps } = props
    return (
        <TooltipPrimitive.Content
            sideOffset={sideOffset}
            className={clsx(
                'animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 flex max-w-xs items-center gap-x-3 rounded-xl border border-neutral-200 bg-white px-3 py-1.5 text-sm shadow-xs dark:border-neutral-700 dark:bg-neutral-900',
                className,
            )}
            {...otherProps}
        >
            {children}
        </TooltipPrimitive.Content>
    )
}
TooltipContent.displayName = TooltipPrimitive.Content.displayName

export { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger }
